import React from "react";

const SkeletonCalendarTimeline: React.FC = () => {
  return (
    <div className="flex-1 animate-pulse flex-col h-full">
      <div className="flex flex-col justify-between h-full flex-1">
        {/* Navigation Header */}
        <div className="flex flex-row items-center py-4 border-t border-x border-gray-200 rounded-t-lg">
          <div className="flex-1 flex justify-between items-center">
            <div className="w-24" />
            <div className="flex justify-center space-x-4 px-3 items-center">
              <div className="w-6 h-3 bg-gray-200 rounded" />
              <div className="h-5 w-40 bg-gray-200 rounded" />
              <div className="w-6 h-3 bg-gray-200 rounded" />
            </div>
            <div className="flex w-24 items-center justify-end space-x-6 py-1 pr-4">
              <div className="w-4 h-4 bg-gray-200 rounded" />
              <div className="w-4 h-4 bg-gray-200 rounded" />
            </div>
          </div>
        </div>

        {/* Calendar Content */}
        <div className="overflow-x-auto border rounded-b-lg bg-white flex-1 flex-col overflow-hidden">
          <div className="w-full flex flex-col">
            {/* Month Headers */}
            <div className="flex text-xs font-semibold text-center text-gray-700">
              <div
                className="flex items-center justify-center border border-gray-100 bg-gray-50"
                style={{ width: "424.257px", height: "30px" }}
              >
                <div className="w-20 h-3 bg-gray-300 rounded" />
              </div>
              <div
                className="flex items-center justify-center border border-gray-100 bg-gray-50"
                style={{ width: "410.571px", height: "30px" }}
              >
                <div className="w-20 h-3 bg-gray-300 rounded" />
              </div>
              <div
                className="flex items-center justify-center border border-gray-100 bg-gray-50"
                style={{ width: "123.171px", height: "30px" }}
              >
                <div className="w-20 h-3 bg-gray-300 rounded" />
              </div>
            </div>

            {/* Week Ranges */}
            <div className="flex text-[10px] text-center text-gray-500">
              {Array(10)
                .fill(null)
                .map((_, i) => (
                  <div
                    key={i}
                    className={`py-1 flex items-center justify-center ${
                      i % 2 === 0 ? "bg-gray-100" : "bg-gray-200"
                    }`}
                    style={{
                      width: "95.8px",
                      borderRight:
                        i === 4 || i === 8 ? "none" : "1px solid white",
                    }}
                  >
                    <div className="w-12 h-3 bg-gray-300 rounded" />
                  </div>
                ))}
            </div>

            {/* Event Grid */}
            <div
              className="relative overflow-x-hidden overflow-y-auto scrollbar-hide rounded-b-lg min-h-[320px] max-h-[320px]"
              style={{ height: "380px" }}
            >
              <div
                className="absolute top-0 left-0 w-full flex min-h-[320px]"
                style={{ height: "380px" }}
              >
                {Array(10)
                  .fill(null)
                  .map((_, i) => (
                    <div
                      key={i}
                      className={`${
                        i % 2 === 0 ? "bg-gray-50" : "bg-gray-100"
                      } border-r border-white`}
                      style={{ width: "95.8px" }}
                    />
                  ))}
              </div>

              {/* Simulated milestone bars */}
              <div
                className="absolute"
                style={{ top: "35px", left: "20.257px", width: "396.886px" }}
              >
                <div className="h-[68px] bg-gray-300 rounded" />
              </div>

              <div
                className="absolute"
                style={{ top: "115px", left: "200.486px", width: "369.514px" }}
              >
                <div className="h-[68px] bg-gray-300 rounded" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonCalendarTimeline;
